import { Box, Button, Tab, Tabs, Typography } from "@mui/material";
import FirstLineContainer from "components/common/FirstLineContainer";
import React, { useState } from "react";
import Process from "./Process";
import RuleSet from "./RuleSet";
import { Link } from "react-router-dom";
import {
  useFetchAllRuleSet,
  useFetchRuleProcesses,
  useFetchAllRules,
} from "hooks/useRuleConfigProcess";

function RuleBuilder() {
  const [tab, settab] = useState(0);
  const [processList, fetchRuleProcesses] = useFetchRuleProcesses();
  const [allRuleSets, fetchAllRuleSets] = useFetchAllRuleSet();
  const [allRules] = useFetchAllRules(false);
  return (
    <div>
      <FirstLineContainer>
        <Typography variant="h6" sx={{ textAlign: "left", flex: 1 }}>
          <Box component="span" fontWeight="fontWeightBold">
            Rules Configuration
          </Box>
        </Typography>
        <Link
          to="/rule-builder/create-rulset"
          style={{ textDecoration: "none", color: "white" }} // Apply white and remove underline
        >
          Create RuleSet
        </Link>
      </FirstLineContainer>

      <Box>
        <Tabs value={tab} onChange={(e, v) => settab(v)}>
          <Tab label="Process" />
          <Tab label="RuleSet" />
        </Tabs>
      </Box>
      <Box>
        {tab === 0 && (
          <Process
            tabValue={tab}
            index={0}
            processList={processList}
            refreshProcesses={fetchRuleProcesses}
            allRuleSets={allRuleSets}
          />
        )}
        {tab === 1 && (
          <RuleSet
            tabValue={tab}
            index={1}
            processList={processList}
            allRuleSets={allRuleSets}
            refreshRuleSets={fetchAllRuleSets}
            allRules={allRules}
          />
        )}
      </Box>
    </div>
  );
}

export default RuleBuilder;
